<template>
    <g>
        <g v-if="rotors" :transform="`scale(1,-1) translate(0,${ship.particulars.D+this.ship.particulars.B+this.margin})`">
            <g v-for="(x,i) in xPositions" :transform="`translate(${scaleX(x)},0)`">
                <path 
                    v-if="rotors.placement[0][i] || rotors.placement[1][i] || rotors.placement[2][i]"
                    :d="`M -${rotors.D},0 L -${rotors.D},${rotors.h} L ${rotors.D},${rotors.h} L ${rotors.D},0` "
                    :style="`fill:#ffffff;stroke:#3b8ede;stroke-width:${lppScale};cursor:pointer;fill-opacity:0.0`"
                />
            </g>
        </g>
        <g v-if="rotors" :transform="`scale(1,-1) translate(0,${0.5*this.ship.particulars.B})`">
            <g v-for="(x,i) in xPositions" :transform="`translate(${scaleX(x)},0)`">
                <g :transform="`translate(0,${sideRotorDist})`">
                <path 
                    :d="`M -${rotors.D},-${rotors.D} L ${rotors.D},-${rotors.D} L ${rotors.D},${rotors.D} L -${rotors.D},${rotors.D} Z` "
                    :style="`fill:#ffffff;stroke:#000000;stroke-width:${0.3*lppScale};cursor:pointer;fill-opacity:0.0`"
                    v-on:click.stop="toggleRotor([0,i])"
                />
                <circle v-if="rotors.placement[0][i]" :r="rotors.D/2" v-on:click.stop="toggleRotor([0,i])" :style="`fill:#ffffff;stroke:#3b8ede;stroke-width:${lppScale};cursor:pointer;fill-opacity:0.0`"/>
                </g>
                <g :transform="`translate(0,0)`">
                <path 
                    :d="`M -${rotors.D},-${rotors.D} L ${rotors.D},-${rotors.D} L ${rotors.D},${rotors.D} L -${rotors.D},${rotors.D} Z` "
                    :style="`fill:#ffffff;stroke:#000000;stroke-width:${0.3*lppScale};cursor:pointer;fill-opacity:0.0`"
                    v-on:click.stop="toggleRotor([1,i])"
                />
                <circle v-if="rotors.placement[1][i]" :r="rotors.D/2" v-on:click.stop="toggleRotor([1,i])" :style="`fill:#ffffff;stroke:#3b8ede;stroke-width:${lppScale};cursor:pointer;fill-opacity:0.0`"/>
                </g>
                <g :transform="`translate(0,-${sideRotorDist})`">
                <path 
                    :d="`M -${rotors.D},-${rotors.D} L ${rotors.D},-${rotors.D} L ${rotors.D},${rotors.D} L -${rotors.D},${rotors.D} Z` "
                    :style="`fill:#ffffff;stroke:#000000;stroke-width:${0.3*lppScale};cursor:pointer;fill-opacity:0.0`"
                    v-on:click.stop="toggleRotor([2,i])"
                />
                <circle v-if="rotors.placement[2][i]" :r="rotors.D/2" v-on:click.stop="toggleRotor([2,i])" :style="`fill:#ffffff;stroke:#3b8ede;stroke-width:${lppScale};cursor:pointer;fill-opacity:0.0`"/>
                </g>
            </g>
        </g>
    </g>
</template>

<script>
export default {
    name: "ShipFlettners",
    props: {
        xPositions: Array,
        rotors: Object,
        ship: Object,
        margin: Number,
        scaleX: Function,
        scaleY: Function,
        scaleZ: Function,
        scaleXY: Function,
        scaleXZ: Function,
        lppScale: Number
    },
    computed: {
        sideRotorDist: function() {
            return 0.5 * this.ship.particulars.B - 1.2 * this.rotors.D;
        }
    },
    methods: {
        toggleRotor: function(rotor) {
        this.$emit("onToggleRotor", rotor);
        }
    }
}
</script>